export default __webpack_public_path__ + "locales/sk/DownloadDialog.json?hash=d4340e043d61e45ce66783c2b52f97be";